import { WebApiService } from '../../../plugins/webApiService'
import { Events } from '../../../plugins/events'
import { SendRequestModel } from '../../../plugins/models/SendRequestModel'
import ProjectCreateRequest from '../../../projects/base/i-service/models/ProjectCreateRequest';
import ProjectUpdateRequest from '../../../projects/base/i-service/models/ProjectUpdateRequest';
import ProjectEditCustomerRequest from '../../../projects/base/i-service/models/ProjectEditCustomerRequest';
import ProjectEditNameRequest from '../../../projects/base/i-service/models/ProjectEditNameRequest';
import ProjectImageEditRequest from '../../../projects/base/i-service/models/ProjectImageEditRequest';
import ProjectEditStatusRequest from '../../../projects/base/i-service/models/ProjectEditStatusRequest';
import ProjectGetBuIdRequest from '../../../projects/base/i-service/models/ProjectGetBuIdRequest';
import ProjcetRemoveRequest from '../../../projects/base/i-service/models/ProjcetRemoveRequest';
import ProjectSearchRequest from '../../../projects/base/i-service/models/ProjectSearchRequest';
import WsResponseModelT from '../../../schema-builder-server/models/WsResponseModelT';
import BaseProjectResponse from '../../../projects/base/i-service/models/BaseProjectResponse';
import BaseProjectSearchResponse from '../../../projects/base/i-service/models/BaseProjectSearchResponse';

export default class ProjectBaseService {
	private url?: string;
	private cookieName: string;
	private appWebSettingsPath?: string;
	private apiUrlProperty?: string;

	CreateEvent = new Events<WsResponseModelT<BaseProjectResponse>>();
	UpdateEvent = new Events<WsResponseModelT<BaseProjectResponse>>();
	GetProjectsEvent = new Events<WsResponseModelT<Array<number>>>();
	EditCustomerEvent = new Events<WsResponseModelT<Boolean>>();
	EditNameEvent = new Events<WsResponseModelT<Boolean>>();
	EditImageUrlEvent = new Events<WsResponseModelT<String>>();
	EditStatusEvent = new Events<WsResponseModelT<Boolean>>();
	GetIdEvent = new Events<WsResponseModelT<BaseProjectResponse>>();
	RemoveEvent = new Events<WsResponseModelT<Boolean>>();
	SearchEvent = new Events<WsResponseModelT<BaseProjectSearchResponse>>();

	subscribeEvents = async () => {
		const self = this;
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		webApiService.on('ProjectBaseService', 'Create', 'Main', (res: WsResponseModelT<BaseProjectResponse>) => {
			self.CreateEvent.trigger(res);
		});
		webApiService.on('ProjectBaseService', 'Update', 'Main', (res: WsResponseModelT<BaseProjectResponse>) => {
			self.UpdateEvent.trigger(res);
		});
		webApiService.on('ProjectBaseService', 'GetProjects', 'Main', (res: WsResponseModelT<Array<number>>) => {
			self.GetProjectsEvent.trigger(res);
		});
		webApiService.on('ProjectBaseService', 'EditCustomer', 'Main', (res: WsResponseModelT<Boolean>) => {
			self.EditCustomerEvent.trigger(res);
		});
		webApiService.on('ProjectBaseService', 'EditName', 'Main', (res: WsResponseModelT<Boolean>) => {
			self.EditNameEvent.trigger(res);
		});
		webApiService.on('ProjectBaseService', 'EditImageUrl', 'Main', (res: WsResponseModelT<String>) => {
			self.EditImageUrlEvent.trigger(res);
		});
		webApiService.on('ProjectBaseService', 'EditStatus', 'Main', (res: WsResponseModelT<Boolean>) => {
			self.EditStatusEvent.trigger(res);
		});
		webApiService.on('ProjectBaseService', 'GetId', 'Main', (res: WsResponseModelT<BaseProjectResponse>) => {
			self.GetIdEvent.trigger(res);
		});
		webApiService.on('ProjectBaseService', 'Remove', 'Main', (res: WsResponseModelT<Boolean>) => {
			self.RemoveEvent.trigger(res);
		});
		webApiService.on('ProjectBaseService', 'Search', 'Main', (res: WsResponseModelT<BaseProjectSearchResponse>) => {
			self.SearchEvent.trigger(res);
		});
	}

	constructor(url?: string, cookieName?: string, appWebSettingsPath?: string, apiUrlProperty?: string) {
		this.url = url;
		this.cookieName = cookieName ?? "Auth-Token";
		this.appWebSettingsPath = appWebSettingsPath && [location.host, appWebSettingsPath].join("/");
		this.apiUrlProperty = apiUrlProperty;
		this.subscribeEvents();
	}

	/**
	 * * Создать проект
	 */
	async Create(model: ProjectCreateRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'ProjectBaseService',
			Method: 'Create',
			Value: typeof(model) === 'object' ? JSON.stringify(model) : model,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Создать проект
	 */
	async Update(model: ProjectUpdateRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'ProjectBaseService',
			Method: 'Update',
			Value: typeof(model) === 'object' ? JSON.stringify(model) : model,
		})

		webApiService.send(sendRequest);
	}

	async GetProjects() {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'ProjectBaseService',
			Method: 'GetProjects',
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Поменять заказчика
	 */
	async EditCustomer(model: ProjectEditCustomerRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'ProjectBaseService',
			Method: 'EditCustomer',
			Value: typeof(model) === 'object' ? JSON.stringify(model) : model,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * поменять имя проекту
	 */
	async EditName(model: ProjectEditNameRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'ProjectBaseService',
			Method: 'EditName',
			Value: typeof(model) === 'object' ? JSON.stringify(model) : model,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Изменит урл изображения
	 */
	async EditImageUrl(request: ProjectImageEditRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'ProjectBaseService',
			Method: 'EditImageUrl',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Поменять статус проекта
	 */
	async EditStatus(model: ProjectEditStatusRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'ProjectBaseService',
			Method: 'EditStatus',
			Value: typeof(model) === 'object' ? JSON.stringify(model) : model,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Получить по ид
	 */
	async GetId(request: ProjectGetBuIdRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'ProjectBaseService',
			Method: 'GetId',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Удалить проект
	 */
	async Remove(request: ProjcetRemoveRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'ProjectBaseService',
			Method: 'Remove',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Поиск по проектам
	 */
	async Search(model: ProjectSearchRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'ProjectBaseService',
			Method: 'Search',
			Value: typeof(model) === 'object' ? JSON.stringify(model) : model,
		})

		webApiService.send(sendRequest);
	}

	 // async methods
	/**
	 * * Создать проект
	 */
	async createAsync(model: ProjectCreateRequest): Promise<BaseProjectResponse> {
		return new Promise<BaseProjectResponse>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'ProjectBaseService',
				Method: 'Create',
				Value: typeof(model) === 'object' ? JSON.stringify(model) : model,
				Callback: (response: WsResponseModelT<BaseProjectResponse>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as BaseProjectResponse)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Создать проект
	 */
	async updateAsync(model: ProjectUpdateRequest): Promise<BaseProjectResponse> {
		return new Promise<BaseProjectResponse>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'ProjectBaseService',
				Method: 'Update',
				Value: typeof(model) === 'object' ? JSON.stringify(model) : model,
				Callback: (response: WsResponseModelT<BaseProjectResponse>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as BaseProjectResponse)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	async getProjectsAsync(): Promise<Array<number>> {
		return new Promise<Array<number>>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'ProjectBaseService',
				Method: 'GetProjects',
				Callback: (response: WsResponseModelT<Array<number>>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as Array<number>)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Поменять заказчика
	 */
	async editCustomerAsync(model: ProjectEditCustomerRequest): Promise<Boolean> {
		return new Promise<Boolean>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'ProjectBaseService',
				Method: 'EditCustomer',
				Value: typeof(model) === 'object' ? JSON.stringify(model) : model,
				Callback: (response: WsResponseModelT<Boolean>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as Boolean)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * поменять имя проекту
	 */
	async editNameAsync(model: ProjectEditNameRequest): Promise<Boolean> {
		return new Promise<Boolean>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'ProjectBaseService',
				Method: 'EditName',
				Value: typeof(model) === 'object' ? JSON.stringify(model) : model,
				Callback: (response: WsResponseModelT<Boolean>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as Boolean)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Изменит урл изображения
	 */
	async editImageUrlAsync(request: ProjectImageEditRequest): Promise<String> {
		return new Promise<String>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'ProjectBaseService',
				Method: 'EditImageUrl',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<String>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as String)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Поменять статус проекта
	 */
	async editStatusAsync(model: ProjectEditStatusRequest): Promise<Boolean> {
		return new Promise<Boolean>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'ProjectBaseService',
				Method: 'EditStatus',
				Value: typeof(model) === 'object' ? JSON.stringify(model) : model,
				Callback: (response: WsResponseModelT<Boolean>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as Boolean)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Получить по ид
	 */
	async getIdAsync(request: ProjectGetBuIdRequest): Promise<BaseProjectResponse> {
		return new Promise<BaseProjectResponse>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'ProjectBaseService',
				Method: 'GetId',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<BaseProjectResponse>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as BaseProjectResponse)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Удалить проект
	 */
	async removeAsync(request: ProjcetRemoveRequest): Promise<Boolean> {
		return new Promise<Boolean>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'ProjectBaseService',
				Method: 'Remove',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<Boolean>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as Boolean)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Поиск по проектам
	 */
	async searchAsync(model: ProjectSearchRequest): Promise<BaseProjectSearchResponse> {
		return new Promise<BaseProjectSearchResponse>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'ProjectBaseService',
				Method: 'Search',
				Value: typeof(model) === 'object' ? JSON.stringify(model) : model,
				Callback: (response: WsResponseModelT<BaseProjectSearchResponse>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as BaseProjectSearchResponse)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

}